module.exports = __webpack_public_path__ + "img/default_girl.fb8a8bf7.png";